import CouponControls from "./CouponControls";
import FashionCard from "./FashionCard";

function FashionSection(props) {
  const { fashions } = props;

  return (
    <>
      <div className="yourprod-header">
        <h3>Fashion Items</h3>

        <CouponControls category="fashion" {...props} />
      </div>

      <div className="products-grid">
        {fashions.map((fashion) => (
          <FashionCard key={fashion.$id} fashion={fashion} {...props} />
        ))}
      </div>
    </>
  );
}

export default FashionSection;
